import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "suggestions-card card mb-4 border-0 border-radius d-block bg-white border-0 shadow-none" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = { class: "trezo-card-content" }
const _hoisted_4 = { class: "p-0 m-0 list-unstyled" }
const _hoisted_5 = { class: "user d-flex align-items-center" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "d-block fw-medium text-black" }
const _hoisted_8 = { class: "text-xs" }
const _hoisted_9 = { class: "action d-flex align-items-center" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"trezo-card-header d-flex align-items-center justify-content-between\" data-v-37adc013><div class=\"trezo-card-title\" data-v-37adc013><h5 class=\"mb-0 fw-semibold\" data-v-37adc013>Suggestions</h5><p class=\"fw-normal\" data-v-37adc013>People you may know</p></div><div class=\"trezo-card-subtitle\" data-v-37adc013><div class=\"trezo-card-header-menu position-relative\" data-v-37adc013><div class=\"dropdown action-opt\" data-v-37adc013><button class=\"btn bg-transparent p-0\" type=\"button\" data-bs-toggle=\"dropdown\" aria-expanded=\"false\" data-v-37adc013><i class=\"ri-more-2-fill\" data-v-37adc013></i></button><ul class=\"dropdown-menu dropdown-menu-end bg-white border box-shadow\" data-v-37adc013><li data-v-37adc013><a class=\"dropdown-item\" href=\"javascript:;\" data-v-37adc013> This Day </a></li><li data-v-37adc013><a class=\"dropdown-item\" href=\"javascript:;\" data-v-37adc013> This Week </a></li><li data-v-37adc013><a class=\"dropdown-item\" href=\"javascript:;\" data-v-37adc013> This Month </a></li><li data-v-37adc013><a class=\"dropdown-item\" href=\"javascript:;\" data-v-37adc013> This Year </a></li></ul></div></div></div></div>", 1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              class: "d-flex align-items-center justify-content-between"
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("img", {
                  src: user.image,
                  class: "rounded-circle",
                  alt: "user-image"
                }, null, 8, _hoisted_6),
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(user.name), 1),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(user.mutualFriends) + " mutual friends ", 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  type: "button",
                  class: "d-flex align-items-center justify-content-center p-0 rounded-circle",
                  onClick: ($event: any) => (_ctx.removeUser(index))
                }, [...(_cache[0] || (_cache[0] = [
                  _createElementVNode("i", { class: "ri-delete-bin-7-line" }, null, -1)
                ]))], 8, _hoisted_10),
                _createElementVNode("button", {
                  type: "button",
                  class: "d-flex align-items-center justify-content-center p-0 rounded-circle",
                  onClick: ($event: any) => (_ctx.addUser(user))
                }, [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("i", { class: "ri-user-add-line" }, null, -1)
                ]))], 8, _hoisted_11)
              ])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}